@if (step() === 0) {
  <app-introduction (continue)="step.set(1)" />
}
@if (step() === 1) {
  <app-onboarding-step-1 (back)="step.set(0)" (continue)="step.set(2)" />
}
@if (step() === 2) {
  <app-onboarding-step-2 (back)="step.set(1)" (continue)="onStep2Continue($event)" />
}
@if (step() === 3) {
  <app-onboarding-visual (back)="step.set(2)" (continue)="step.set(5)" />
}
@if (step() === 4) {
  @let _tableChart = tableChart();
  @if (_tableChart) {
    <app-onboarding-table-chart [chart]="_tableChart" (back)="step.set(2)" (continue)="step.set(5)" />
  }
}
@if (step() === 5) {
  <app-onboarding-step-3 (continue)="onStep3Continue($event)" />
}
@if (step() === 6) {
  <app-onboarding-assigning (back)="step.set(5)" (continue)="goToThemeExtension(6)" />
}
@if (step() === 7) {
  <app-onboarding-final [productId]="productId()" />
}
@if (step() === 8) {
  @let _chart = chart();
  @let _productId = productId();
  @if (_chart && _productId) {
    <app-onboarding-chart
      [chart]="_chart"
      [productId]="_productId"
      (back)="step.set(2)"
      (continue)="goToThemeExtension(8)"
    />
  }
}
@if (step() === 9) {
  <app-onboarding-theme-extension
    [previousStep]="themeExtensionFrom()"
    (back)="step.set($event)"
    (skip)="step.set(7)"
    (continue)="step.set(7)"
  />
}
